import fetch from "auth/FetchInterceptor";
import store from "redux/store";
import { UPDATE_NOTIFICATIONS } from "redux/constants/Menu";
import { UPDATE_PERMISSOES } from "redux/constants/Permissoes";
import { UPDATE_USER } from "redux/constants/User";
import { UPDATE_TENANTS, ALTERAR_TENANT_ATUAL } from "redux/constants/Tenant";

const MenuService = {};

/*
    Injeta na store do usuário os dados do menu
*/
MenuService.populateMenuData = async function () {
	const menuData = await MenuService.getMenuData();

	store.dispatch({
		type: UPDATE_USER,
		name: menuData.usuario.nome,
		email: menuData.usuario.email ?? null,
		role: "Usuário",
		grupo_usuario: menuData.usuario.grupo_usuario || null,
		id_comercializador: menuData.usuario.id_comercializador ?? null,
		id_parceiro: menuData.usuario.id_parceiro ?? null,
	});

	store.dispatch({
		type: UPDATE_NOTIFICATIONS,
		empresasComErros:
			menuData.notificacoes?.total_empresas_com_erros ?? 0,
	});

	store.dispatch({
		type: UPDATE_PERMISSOES,
		permissoes: menuData.permissoes,
	});

	store.dispatch({
		type: UPDATE_TENANTS,
		tenants: menuData.tenants,
	});

	const tenants = Array.isArray(menuData.tenants) ? menuData.tenants : [];
	const atual = store.getState().tenants?.tenantAtual;
	const atualValido =
		atual && tenants.some((t) => t.nome_schema === atual);

	if (!atualValido && tenants.length > 0) {
		const preferido =
			tenants.find((t) => t.nome_schema === "tenant_base") || tenants[0];
		store.dispatch({
			type: ALTERAR_TENANT_ATUAL,
			tenantAtual: preferido.nome_schema,
		});
	}
};

// TODO: após clonar o skeleton, ajustar essa função
MenuService.getMenuData = function () {
	return fetch({
		url: "/v1/rpc/menu",
		method: "get",
	});
};

export default MenuService;
